import { render, staticRenderFns } from "./Bus.vue?vue&type=template&id=e8b00fae&scoped=true&"
import script from "./Bus.vue?vue&type=script&lang=js&"
export * from "./Bus.vue?vue&type=script&lang=js&"
import style0 from "./Bus.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Bus.vue?vue&type=style&index=1&id=e8b00fae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b00fae",
  null
  
)

export default component.exports